import moment from 'moment';
import * as Yup from 'yup';
export interface IExperience {
  work_exp_id?: string;
  from_date: string;
  to_date: string;
  organization: string;
  designation: string;
  department: string;
  district: string;
  job_type: string;
}

export const experienceInitialValues = {
  work_exp_id: '',
  from_date: moment().format('YYYY-MM-DD'),
  to_date: moment().format('YYYY-MM-DD'),
  organization: '',
  designation: '',
  department: '',
  district: '',
  job_type: ''
};

export const ExperienceValidationSchema = Yup.object().shape({
  from_date: Yup.string().nullable(),
  to_date: Yup.string().nullable(),
  organization: Yup.string().required('Organization is required'),
  designation: Yup.string().required('Designation is required'),
  department: Yup.string().required('Department is required')
});

export const JobTypeOptions: Array<{
  label: string;
  value: string;
}> = [
  {
    label: 'Private',
    value: '1'
  },
  {
    label: 'Public',
    value: '2'
  }
];
